import { Credit } from 'types/api.types';
import { ContributionClassRolesDDL } from 'types/contribution';
import { Role } from './types';

export const getOrderedRoles = (
  credit: Credit,
  contributionClassNames?: ContributionClassRolesDDL
): Role[] => {
  if (!contributionClassNames) {
    return [];
  }
  const groupedSortOrder = Object.values(contributionClassNames).map(
    (className) => className.key
  );
  return groupedSortOrder.reduce((acc, val) => {
    if (credit.roles[val]) {
      return acc.concat(credit.roles[val]);
    }
    return acc;
  }, [] as Role[]);
};

export const AVATAR_SIZE = 52;

const getColumnSize = (percent: number, totalWidth?: number) => {
  if (!totalWidth) {
    return undefined;
  }
  return (totalWidth - AVATAR_SIZE) * percent;
};

export const getColumns = ({
  totalWidth,
}: {
  loading: boolean;
  totalWidth?: number;
}) => [
  {
    accessorKey: 'accessory',
    size: AVATAR_SIZE,
    accessory: true,
  },
  {
    accessorKey: 'title',
    header: 'Title',
    minSize: 42,
    sx: { pl: 0 },
    size: getColumnSize(0.25, totalWidth),
    enableResizing: true,
  },
  {
    accessorKey: 'roles',
    header: 'Roles',
    size: getColumnSize(0.25, totalWidth),
    minSize: 56,
    enableResizing: true,
  },
  {
    accessorKey: 'date',
    header: 'Last Modified',
    size: getColumnSize(0.25, totalWidth),
    minSize: 112,
    enableResizing: true,
  },
  {
    accessorKey: 'addedBy',
    header: 'Added by',
    size: getColumnSize(0.25, totalWidth),
  },
  {
    accessorKey: 'gap',
    size: 0,
  },
];
